export default "__VITE_ASSET__22977000__"